import { parseDate, today } from '@internationalized/date';

export const useCalendarPopover = defineStore('calendarPopover', {
  state: () => ({
    checkIn: null,
    checkOut: null,
    facility: null,
    mode: 'single',
  }),
  actions: {
    setFacility(facility) {
      this.facility = facility;
    },
    setCheckIn(date) {
      this.checkIn = date ? {
        year: date.year,
        month: date.month,
        day: date.day
      } : null;
    },
    setCheckOut(date) {
      this.checkOut = date ? {
        year: date.year,
        month: date.month,
        day: date.day
      } : null;
    },
    setMode(mode) {
      this.mode = mode;
    },
    reset() {
      this.checkIn = null;
      this.checkOut = null;
      this.mode = 'single';
    }
  },
  getters: {
    today: () => {
      const now = new Date();
      if (now.getHours() >= 18) {
        return today().add({ days: 1 });
      } else {
        return today();
      }
    },
    checkInDate: (state) => {
      return state.checkIn
        && parseDate(`${state.checkIn.year}-${String(state.checkIn.month).padStart(2, '0')}-${String(state.checkIn.day).padStart(2, '0')}`)
    },
    checkInDateISO: (state) => {
      if (state.checkIn) {
        return `${String(state.checkIn.month).padStart(2, '0')}/${String(state.checkIn.day).padStart(2, '0')}/${state.checkIn.year}`;
      }
      const store = useCalendarPopover();
      const todayDate = store.today;
      return `${String(todayDate.month).padStart(2, '0')}/${String(todayDate.day).padStart(2, '0')}/${todayDate.year}`;
    },
    checkInDateISODisplay: (state) => {
      if (state.checkIn) {
        return `${String(state.checkIn.month).padStart(2, '0')}/${String(state.checkIn.day).padStart(2, '0')}`;
      }
      const store = useCalendarPopover();
      const todayDate = store.today;
      return `${String(todayDate.month).padStart(2, '0')}/${String(todayDate.day).padStart(2, '0')}`;
    },
    checkOutDateISO: (state) => {
      if (state.checkOut && state.mode === 'range') {
        return `${String(state.checkOut.month).padStart(2, '0')}/${String(state.checkOut.day).padStart(2, '0')}/${state.checkOut.year}`;
      }
      return null;
    },
    checkOutDateISODisplay: (state) => {
      if (state.checkOut && state.mode === 'range') {
        return `${String(state.checkOut.month).padStart(2, '0')}/${String(state.checkOut.day).padStart(2, '0')}`;
      }
      return null;
    },
    checkOutDate: (state) => {
      return state.checkOut
        && parseDate(`${state.checkOut.year}-${String(state.checkOut.month).padStart(2, '0')}-${String(state.checkOut.day).padStart(2, '0')}`)
    },
    isRange: (state) => {
      return state.mode === 'range';
    },
    totalDays: (state) => {
      if (!state.checkOut || !state.checkIn) return 0;
      
      const checkInDate = new Date(state.checkIn.year, state.checkIn.month - 1, state.checkIn.day);
      const checkOutDate = new Date(state.checkOut.year, state.checkOut.month - 1, state.checkOut.day);
      const diffTime = checkOutDate.getTime() - checkInDate.getTime();
      const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
      
      return diffDays + 1; // Include both start and end dates
    }
  },
  persist: {
    storage: sessionStorage,
    paths: ['checkIn', 'checkOut']
  }
});
